import 'fomantic-ui-css/semantic'
import deepMerge from 'deepmerge'

import {ApiRequest} from "./request";

export const setupDropdown = ($context, app) => {

    // Get dropdown elements
    let $dropdowns = $context.find('.ui.dropdown')

    // Dropdowns config + callbacks
    let configDefault = {

        // transition: 'fade down',
        onChange: async function(value, text, $selectedItem) {

            // Get teh change event name
            const changeEvent = this.getAttribute('data-event') || this.getAttribute('name')

            // Emit event with input values
            app.events.emit('kx_dropdownSelect:' + changeEvent, {
                value, text, selectedItem: $selectedItem, el: this
            })

            // GoToUrl
            if(this.dataset.tourl !== undefined) {
                window.location.href = value
            }

            // Make an api request
            let endpoint = this.dataset.endpoint
            if(endpoint !== undefined) {
                endpoint = decodeURIComponent(endpoint).replace(':status', value)
                const response = await ApiRequest(endpoint)
                app.events.emit('kx_linechart:new-data:' + this.getAttribute('id'), response)
            }

        },
        onShow: function() {

            const el = this
            const $dropdown = $(el).parents('.form-field').find('.ui.dropdown')

            // Setup perfect scrollbar for all dropdowns
            /*let dropdowns = document.querySelectorAll('body.is-desktop:not(.os-macintosh) .ui.dropdown:not(.native-scroll)')

            dropdowns.forEach((el) => {
                let menu = el.querySelector('.menu')

                // Init PS only once
                if( menu != null && !menu.classList.contains('ps') ) {
                    new PerfectScrollbar(menu, psConfig())
                }
            })*/

            // Add 'open' class to form-field-inner
            let formFieldInner = this.closest('.form-field-inner')
            if(formFieldInner !== null)
                formFieldInner.classList.add('open')

            setTimeout(function(){
                if($dropdown.hasClass('upward')) formFieldInner.classList.add('upward')
            }, 0)

        },
        onHide: function () {

            // Remove 'open' class from the form-field-inner
            let formFieldInner = this.closest('.form-field-inner')
            if(formFieldInner !== null) formFieldInner.classList.remove('open', 'upward')
        }
    }

    let config = {
        'customer-picker': {
            fullTextSearch: 'exact'
        },
        'mail-illustration': {
            clearable: true,
            placeholder: 'No image'
        },
        'clearable': {
            clearable: true,
            placeholder: 'any'
        }
    }

    $dropdowns.each(function (index, element){

        let options = configDefault
        let customConfig = element.dataset.config

        // Add or overwrite chart options with custom ones
        if (customConfig && config[customConfig]) {
            options = deepMerge(configDefault, config[customConfig])
        }

        // Create the element
        const $element = $(element)

        // Get the maximum number of allowed options to select
        if($element.data('max')) options.maxSelections = $element.data('max')

        // Init dropdowns
        const instance = $element.dropdown(options)

    })

}

/**
 * Init dropdowns
 *
 * @param app
 */
function initDropdowns(app) {
    setupDropdown($('body'), app)
}

/**
 * Init sliders
 *
 * @param app
 */
function initSliders(app) {
    // Get slider elements
    let $sliders = $('.ui.slider')

    $sliders.each(function(){
        let $slider = $(this)
        let element = this

        let steps = JSON.parse(decodeURIComponent($slider.data('steps')))

        $slider.slider({
            ...steps,
            onMove: function (value) {
                app.events.emit('kx_sliderOnMove:' + element.getAttribute('id'),{
                    value, el: this
                })
            },
            onChange: function(){
                //
            }
        })

        // Update info when page loads
        setTimeout(function(){
            app.events.emit('kx_sliderOnMove:' + element.getAttribute('id'),{
                value: steps.start, el: element
            })
        }, 100)

    })
}

export default function SemanticUICom(app) {

    initDropdowns(app)
    initSliders(app)

    // Event to set values
    app.events.on('kx_dropdownSetSelected', function(data){

        // Get parent dropdown element
        let $dd = $(data.field).parent('.ui.dropdown')

        $dd.dropdown('clear')

        if(Array.isArray(data.values)) {
            data.values.forEach((val) => {
                $dd.dropdown('set selected', val)
            })
        } else {
            $dd.dropdown('set selected', data.values)
        }
    })

    // Event to clear dropdowns within DOM element
    app.events.on('kx_dropdownClear', function(data){
        $(data.element).find('.ui.dropdown').dropdown('clear')
    })

}
